import React, { useState } from "react";
import { Row, Col, Form, Button, Modal, Alert} from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';
import ErrorAlert from './ErrorAlert';
import C from '../lib/Config';

function MyVerticallyCenteredSuccessAlert(props) {
    return (
        <Modal {...props} size="md" id="alertBox" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <Alert>
                    <Alert.Heading className="mb-4 text-white fs-18 justify-content-center text-center" style={{ width: "100%" }}><h3>Success !!</h3></Alert.Heading>
                    <p className="text-white d-flex justify-content-center mb-4">You have registered successfully.</p>
                    <div className="text-white d-flex justify-content-center mt-4"><Link className="btn btn-info fs-13" to="/sign-in" >Close</Link></div>
                </Alert>
            </Modal.Body>
        </Modal>
    );
}

let time = new Date();
time.setSeconds(time.getSeconds() + 30); // 30 seconds timer

const OtpAuthModal = (props) => {
    const { data, show, closeModal } = props;
    const [digit01, setDigit01] = useState(null);
    const [digit02, setDigit02] = useState(null);
    const [digit03, setDigit03] = useState(null);
    const [digit04, setDigit04] = useState(null);
    const [successAlertshow, setSuccessAlertshow] = useState(false);
    const [successAlertclose, setSuccessAlertclose] = useState(false);
    const [isResendOtpClicked, setIsResendOtpClicked] = useState(false);
    const [errorAlertshow, errorAlertclose] = useState(false);

    const {
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        resume,
        restart,
    } = useTimer({ expiryTimestamp: time, onExpire: () => resetOtpTimer() });

    const inputDataHandler = (event) => {
        if (event.target.name === 'digit-01') {
            setDigit01(event.target.value);
            if(event.target.value !== ''){
            document.getElementById('input-digit-02').focus();
            }
        }
        if (event.target.name === 'digit-02') {
            setDigit02(event.target.value);
            if(event.target.value !== ''){
            document.getElementById('input-digit-03').focus();
            }
        }
        if (event.target.name === 'digit-03') {
            setDigit03(event.target.value);
            if(event.target.value !== ''){
            document.getElementById('input-digit-04').focus();
            }
        }
        if (event.target.name === 'digit-04') {
            setDigit04(event.target.value)
        }
    }

    const resetOtpTimer = () => {
        console.log('---> resetOtpTimer called :: ')
        time = new Date();
        time.setSeconds(time.getSeconds() + 30);
        restart(time);
        pause();
        setIsResendOtpClicked(false);
    }

    const ResendOtpTimer = () => {
        console.log('---> is running status : ' + isRunning)
        const startTimer = () => {
            console.log('---> startTimer called :: ')
            time = new Date();
            time.setSeconds(time.getSeconds() + 30);
            start();
            resume();
            setIsResendOtpClicked(true);
            resendOtp();
        }

        return (
            <div>
                {
                    isResendOtpClicked ?
                    <Col lg='12'>
                        <h4 className="fs-5 mb-2 mt-6 ml-4 otp_modal_content resend_code" style={{ fontSize: '18px' }}>{minutes}</h4>
                        <h4 className="fs-5 mb-2 mt-6 ml-2 otp_modal_content resend_code" style={{ fontSize: '18px' }}>:</h4>
                        <h4 className="fs-5 mb-2 mt-6 ml-2 otp_modal_content resend_code" style={{ fontSize: '18px' }}>{seconds}</h4>
                    </Col> :
                    <Col lg='12'>
                        <a onClick={() => startTimer()}><h4 className="fs-5 mb-2 mt-4 ml-4 otp_modal_content resend_code">Resend Code</h4></a>
                    </Col>
                }
            </div>
        )
    }

    const submitClickHandler = () => {
        if (digit01 !== null && digit02 !== null && digit03 !== null && digit04 !== null) {
            let enteredOtp = Number(`${digit01}${digit02}${digit03}${digit04}`);
            console.log(`---> ENTERED OTP : ${enteredOtp}`);
            verifyOtpAndSubmitForm(enteredOtp);
        } else {
            console.log(`---> INVALID OTP :`);
        }
    }
    const verifyOtpAndSubmitForm = async (enteredOtp) => {
        let formData = data;
        let associateDocList = [];
        data.associatedDoctorDTOList.map((item, i) => {
            let jsonObject = new Object();
            jsonObject['userId'] = item.id
            jsonObject['firstName'] = item.firstName
            jsonObject['lastName'] = item.lastName
            associateDocList.push(jsonObject);
        });
        formData['associatedDoctorDTOList'] = associateDocList;
        formData['otp'] = enteredOtp;
        console.log(`---> FORM DATA WITH OTP : ` + JSON.stringify(formData));
        return fetch(C.getUrl() + '/user/addOrUpdate', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                alert(error);
            } else {
                closeModal();
                setSuccessAlertshow(true);
                setTimeout(() => {
                    setSuccessAlertshow(false);
                }, 3000)
            }
        })
        .catch(err => {
            console.log("Error : " + err);
            errorAlertshow(true);
            setTimeout(() => {
                errorAlertshow(false);
            }, 3000)
        });
    }
    const resendOtp = async () => {
        let formData = data;
        let jsonData = new Object();
        jsonData['firstName'] = formData.firstName;
        jsonData['lastName'] = formData.lastName;
        jsonData['username'] = formData.username;
        console.log('--- INPUT JSON FOR RESEND OTP : ' + JSON.stringify(jsonData))
        setIsResendOtpClicked(true);
        return fetch(C.getUrl() + '/user/addOrUpdate', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(jsonData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                alert(error)
            } else {
                console.log('--- RESEND OTP SUCCESS : ');
                resetOtpInputFields();
            }
        })
        .catch(err => {
            console.log("Error : " + err);
            errorAlertshow(true);
            setTimeout(() => {
                errorAlertshow(false);
            }, 3000)
        });
    }
    const resetOtpInputFields = () => {
        document.getElementById('input-digit-01').value = '';
        document.getElementById('input-digit-02').value = '';
        document.getElementById('input-digit-03').value = '';
        document.getElementById('input-digit-04').value = '';
        setDigit01(null);
        setDigit02(null);
        setDigit03(null);
        setDigit04(null);
    }

    return (
        <div>
            <Modal show={show} animation={true} centered>
                <div className="otp_modal_container">
                    <Modal.Header className="otp_modal_header_container mr-4 mt-4" closeButton onClick={() => closeModal()}>
                        <Modal.Title><h2 className="fs-20 mb-2 ml-4 header_title text-white pt-3">Enter OTP</h2></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            <Row className="mt-1">
                                <Col lg='12'>
                                    <h4 className="fs-5 mb-2 ml-4 otp_modal_content text-white">{`Enter 4 digit code sent on your email address ${data.username}`}</h4>
                                </Col>
                                <Col lg='12' className='pt-4 mb-2 ml-4'>
                                    <Form.Control id='input-digit-01' className="otp_input_box mr-3" pattern="[0-9]*" maxLength={1} size='lg' type='text' placeholder='' name='digit-01' onChange={(event) => inputDataHandler(event)} />
                                    <Form.Control id='input-digit-02' className="otp_input_box mr-3" pattern="[0-9]*" maxLength={1} size='lg' type='text' placeholder='' name='digit-02' onChange={(event) => inputDataHandler(event)} />
                                    <Form.Control id='input-digit-03' className="otp_input_box mr-3" pattern="[0-9]*" maxLength={1} size='lg' type='text' placeholder='' name='digit-03' onChange={(event) => inputDataHandler(event)} />
                                    <Form.Control id='input-digit-04' className="otp_input_box mr-3" pattern="[0-9]*" maxLength={1} size='lg' type='text' placeholder='' name='digit-04' onChange={(event) => inputDataHandler(event)} />
                                </Col>
                                <ResendOtpTimer />
                            </Row>
                        }
                    </Modal.Body>
                    <Modal.Footer className="otp_modal_footer_container">
                        <Button className="otp_submit_button mt-2 mr-20 ml-20 mb-4" variant="secondary" onClick={() => submitClickHandler()}>Submit</Button>
                    </Modal.Footer>
                </div>
            </Modal>
            <MyVerticallyCenteredSuccessAlert show={successAlertshow} />
            <ErrorAlert show={errorAlertshow} alertBody={'Something went wrong. Please try again'}/>
        </div>
    )
}

export default OtpAuthModal;